import { render } from "./ModalNuovaSpesa.vue?vue&type=template&id=067d2f71&scoped=true"
import script from "./ModalNuovaSpesa.vue?vue&type=script&lang=js"
export * from "./ModalNuovaSpesa.vue?vue&type=script&lang=js"

import "./ModalNuovaSpesa.vue?vue&type=style&index=0&id=067d2f71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067d2f71"]])

export default __exports__